// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"453f2ef2","726":"56c05ec2"}[chunkId] + ".chunk.js";
};